<div class="edit-container position-absolute d-block z-index-3 white-background">
  <perfect-scrollbar style="max-width: 100%; top: 0; left: 0;">
    <div class="row mx-0 teal-background">
      <div class="col px-2">
        <h6 class="white-font uppercase p-2 mb-0">
          {{addOrEdit}} Pharmacy
        </h6>
      </div>
    </div>
    <div class="row pt-2 mx-0">
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Pharmacy Name" class="capitalized" aria-label="Pharmacy Name"
            (change)="formatterService.textCapitalize(name);updateSubmitButtonState()" [(ngModel)]="editedPharmacy.name" [formControl]="name" required>
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Address 1" class="capitalized" aria-label="Address1"
            (change)="formatterService.textCapitalize(addressAddress1);updateSubmitButtonState()" [(ngModel)]="editedPharmacy.address.address1"
            [formControl]="addressAddress1">
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Address 2" class="capitalized" aria-label="Address2"
            (change)="formatterService.textCapitalize(addressAddress2);updateSubmitButtonState()" [(ngModel)]="editedPharmacy.address.address2"
            [formControl]="addressAddress2">
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="City" class="capitalized" aria-label="City"
            (change)="formatterService.textCapitalize(addressCity);updateSubmitButtonState()" [(ngModel)]="editedPharmacy.address.city"
            [formControl]="addressCity">
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field>
          <mat-select [(ngModel)]="editedPharmacy.address.province" name="usStates" (selectionChange)="updateSubmitButtonState()">
            <mat-option *ngFor="let provinceState of provincesAndStates" [value]="provinceState">
              {{ provinceState }}
            </mat-option>
          </mat-select>
          <mat-placeholder class="placeholder">
            {{editedPharmacy.address.country === 'United States' ? 'State' : 'Province'}}</mat-placeholder>
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field>
          <mat-select placeholder="Country" [(ngModel)]="editedPharmacy.address.country" name="usStates"
            (selectionChange)="onChangeCountry();updateSubmitButtonState()">
            <mat-option *ngFor="let country of countriesOfTheWorld" [value]="country">
              {{ country }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field>
          <input matInput aria-label="Postal Code" class="uppercased" [(ngModel)]="editedPharmacy.address.postalCode"
            (change)="formatterService.formatPostalCode(addressPostalCode);updateSubmitButtonState()"
            [formControl]="addressPostalCode">
          <mat-placeholder class="placeholder">
            {{editedPharmacy.address.country === 'United States' ? 'Zip Code' : 'Postal Code'}}</mat-placeholder>
          <mat-error *ngIf="addressPostalCode.invalid">
            {{editedPharmacy.address.country === 'United States' ? 'Not a Valid Zip Code' : 'Not a Valid Postal Code'}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Phone Number" aria-label="Phone Number" [(ngModel)]="editedPharmacy.phoneNumber1"
            (change)="formatterService.formatPhoneNumber(phoneNumber1);updateSubmitButtonState()"
            [formControl]="phoneNumber1">
          <mat-error *ngIf="phoneNumber1.invalid">Not a Valid Phone #</mat-error>
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Phone Number - Alternate 1" aria-label="Phone Number - Alternate 1"
            [(ngModel)]="editedPharmacy.phoneNumber2"
            (change)="formatterService.formatPhoneNumber(phoneNumber2);updateSubmitButtonState()"
            [formControl]="phoneNumber2">
          <mat-error *ngIf="phoneNumber2.invalid">Not a Valid Phone #</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Phone Number - Alternate 2" aria-label="Phone Number - Alternate 2"
            [(ngModel)]="editedPharmacy.phoneNumber3"
            (change)="formatterService.formatPhoneNumber(phoneNumber3);updateSubmitButtonState()"
            [formControl]="phoneNumber3">
          <mat-error *ngIf="phoneNumber3.invalid">Not a Valid Phone #</mat-error>
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Fax Number" aria-label="Fax Number" [(ngModel)]="editedPharmacy.faxNumber"
            (change)="formatterService.formatPhoneNumber(faxNumber);updateSubmitButtonState()"
            [formControl]="faxNumber">
          <mat-error *ngIf="faxNumber.invalid">Not a Valid Fax #</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Email" aria-label="Email" [(ngModel)]="editedPharmacy.email"
            [formControl]="email" (change)="updateSubmitButtonState()">
          <mat-error *ngIf="email.invalid">Not a Valid Email</mat-error>
        </mat-form-field>
      </div>
      <div class="col px-2">
        <mat-form-field>
          <input matInput placeholder="Website" aria-label="Website" [(ngModel)]="editedPharmacy.website"
            [formControl]="website" (change)="updateSubmitButtonState()">
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0">
      <div class="col px-2">
        <mat-form-field id="hoursOfOperationInput">
            <input matInput placeholder="Hours of Operation" (click)="setHoursOfOperation()"
            aria-label="Hours of Operation" [readonly]="true" [value]="hoursOfOperation">
        </mat-form-field>
      </div>
    </div>
    <div class="row mx-0 pt-2">
      <div class="col px-2 text-center">
        <button class="btn em-btn em-btn-green" (click)="updatePharmacy()"
          [disabled]="submitButtonDisabledState">{{addOrEdit === 'Add' ? 'Add' : 'Update'}} Pharmacy</button>
      </div>
      <div class="col px-2 text-center">
        <button class="btn em-btn em-btn-green" (click)="cancelUpdate()">Cancel</button>
      </div>
    </div>
  </perfect-scrollbar>
</div>
